<template>
  <ExamReady :path="'/continueEdu'" style="margin-top: -86px;"></ExamReady>
</template>

<script>
  import ExamReady from '@/page/modules/exam/ready'
  export default {
    components: { ExamReady },
    mounted () {
    },
    data () {
      return {
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/page/continueEdu/exam/ready.vue